module.exports = __webpack_public_path__ + "static/media/red-number-4.663cb8ac.png";